import React, { ComponentProps, useMemo } from "react";
import DeltaMathTable from "../../../shared/DeltaMathTable";

const DiffSection: React.FC<{
  sectionInfo: any[];
  assignmentName?: string;
}> = ({ sectionInfo, assignmentName }) => {
  const sectionColumns: ComponentProps<typeof DeltaMathTable>["columns"] =
    useMemo(
      () => [
        {
          Header: "Section ID",
          accessor: "_id",
          align: "left",
        },
        {
          Header: "Section Name",
          accessor: "name",
          align: "left",
        },
        {
          Header: "Teacher Code(s)",
          accessor: "teachers",
          Cell: ({ value }: { value: string[] }) => {
            return <span>{(value || []).join(", ")}</span>;
          },
          align: "left",
        },
      ],
      []
    );

  if (!sectionInfo) return null;
  return (
    <section className="mt-6">
      <h2 className="mb-2 text-lg font-semibold text-gray-900">
        {assignmentName
          ? `Section Summary for ${assignmentName}`
          : "Section Summary"}
      </h2>
      {sectionInfo.length > 0 ? (
        <DeltaMathTable data={sectionInfo} columns={sectionColumns} />
      ) : (
        <div className="text-gray-600">No Sections found</div>
      )}
    </section>
  );
};

export default DiffSection;
